<template>
    <div class="dashboard__list_learner_active">
        <component-induction-message
            :title="'My events'"
            :content="'Here you can find the events you are booked onto.'"
            :link-to="''"
            :theme="'tertiary'"
            :route-name="'dashboard-learner'"
        ></component-induction-message>
        <view-actions
            :title="'Event bookings'"
            :custom-button-active="true"
            :custom-button-text="'View completed events'"
            :submit-button-active="false"
            :cancel-button-active="false"
            @emit-custom="redirectToCompletedEvents"
        ></view-actions>
        <component-list
            :component-grid="DashboardListLearnerGrid"
            :component-table="DashboardListLearnerTable"
            :component-table-name="'dashboard-learner-active'"
            :filters-active="false"
            :filter-search-queryable="true"
            :filter-search-placeholder="$t('dashboard.labels.searchSession')"
            :get-pagination-getter="'getEbsSessionsCustomActivePagination'"
            :get-items-getter="'getEbsSessionsCustomActiveData'"
            :get-items-dispatch="'ebsSessionsGetLearnerActive'"
            :item-name="['event', 'events']"
        />
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import DashboardListLearnerGrid from '@/components/dashboard/list/learner/DashboardListLearnerGrid'
import DashboardListLearnerTable from '@/components/dashboard/list/learner/DashboardListLearnerTable'
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentInductionMessage from '@/components/default/shared/ComponentInductionMessage'

export default {
  name: 'dashboard-list-learner-active',
  components: { ComponentInductionMessage, ViewActions, ComponentList },
  data () {
    return {
      DashboardListLearnerGrid,
      DashboardListLearnerTable
    }
  },
  computed: {
    userName () {
      return this.$store.getters.getAuthUserSecondStageTokenDataNameOutput
    }
  },
  methods: {
    redirectToCompletedEvents () {
      this.$router.push({ name: 'dashboard-completions', query: { view: 'events' } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlistactiveitems.scss";
</style>
